import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { FusionService } from '@shared-angular/services/fusion.service';


export const fusionResolver: ResolveFn<boolean> = async (route, _state) => {
  const fustionService = inject(FusionService);
  const id = route.parent?.params['id'] as string;
  await fustionService.loadFusionInfo(id);
  return true;
};

